import React from 'react';
import { Link } from 'react-router-dom';
import { WHATSAPP } from '../data/contacto';
import MarcoMarca from './MarcoMarca';

// 🟠 Texto provisorio (18/10/2026): lo define An; no lo revisó una abogada. Cada cambio de texto sube VERSION_AVISO en CierreHome.jsx.
const Privacidad = () => (
  <MarcoMarca pantalla="privacidad">
    <div className="gh-panel gh-legal" data-fase="charla">
      <h1>Cómo cuidamos tus datos</h1>
      <p>GUIA es de Córdoba, Argentina. Esto es lo que pasa con lo que escribís en la conversación de la página.</p>
      <h2>Qué guardamos</h2>
      <p>Si dejás tu contacto: tu nombre, tu mail o tu WhatsApp, lo que respondiste en la conversación y el recorrido que hiciste hasta ahí. Si no dejás tu contacto, no guardamos nada que te identifique: solo medimos, de forma anónima, en qué pantallas la gente avanza o se detiene.</p>
      <h2>Para qué</h2>
      <p>Solo para responderte. Te escribimos una vez, dentro del plazo que dice la página. No te sumamos a listas ni te mandamos publicidad.</p>
      <h2>Quién más interviene</h2>
      <p>Usamos proveedores para que la página funcione: el alojamiento de la web (Netlify), la base donde queda tu contacto (Supabase) o una planilla de Google, y un servicio de clasificación (TypeSafe) que lee lo que escribís sobre tu negocio para sugerirte la pregunta que sigue. A ese servicio no le enviamos tu nombre ni tu contacto.</p>
      <h2>Cuánto tiempo</h2>
      <p>Guardamos tu contacto y el recorrido hasta 12 meses. Después los borramos, salvo que ya seas cliente.</p>
      <h2>Tus derechos</h2>
      <p>Podés pedir ver, corregir o borrar tus datos cuando quieras: <a href={`https://wa.me/${WHATSAPP}?text=${encodeURIComponent('Hola, quiero consultar o borrar mis datos.')}`} target="_blank" rel="noopener noreferrer">escribinos por WhatsApp</a>.</p>
      <p><Link to="/">← Volver a la conversación</Link></p>
    </div>
  </MarcoMarca>
);

export default Privacidad;
